import { render, staticRenderFns } from "./ContactEditAddresses.vue?vue&type=template&id=43b81e15&scoped=true"
import script from "./ContactEditAddresses.vue?vue&type=script&lang=ts"
export * from "./ContactEditAddresses.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditAddresses.vue?vue&type=style&index=0&id=43b81e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b81e15",
  null
  
)

export default component.exports